var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"#7b7ff7","dark":""}},[_c('v-app-bar-title',[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('v-btn',_vm._g(_vm._b({attrs:{"color":"#7b7ff7","depressed":"","rounded":"","dark":""},on:{"click":function($event){return _vm.toRescue('/#/about')}}},'v-btn',_vm.attrs,false),_vm.on),[_vm._v("关于")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }